const MAX_LENGTH = 9;

/**
 * Sanitizes a postal code for Braintree by removing any non-alphanumeric, space or dash characters and limiting the length to 9.
 */
export const sanitizePostalCodeForBraintree = (postalCode: string) =>
  postalCode
    .replace(/[^a-zA-Z0-9 -]/g, '')
    .replace(/\s+/g, ' ')
    .slice(0, MAX_LENGTH);
